// src/data/contractTypes.js

// For 'contractTemplate'
const contractTypes = {
  NDA: {
    title: "保密合約",
    pdfName: '保密合約',
    description: "適用於任何可能揭露機密資訊的合作關係",
    downloadPoints: "免費",
    details: [
      "適用於個人與企業間合作。",
      "包含機密資訊保護條款。",
      "可根據具體需求添加條款。",
    ],
  },
  "labor-contract": {
    title: "勞動契約",
    pdfName: '勞動契約',
    description: "適用於雇主僱用勞工（員工）",
    downloadPoints: "50",
    details: [
      "規範雇主與勞工間的權利義務。",
      "包含勞動報酬與工作內容等條款。",
      "符合勞動法令要求。",
    ],
  },
};

export default contractTypes;